/**
 * Micro-haptic feedback for capable devices (Android with Vibration API).
 * iOS Safari does not expose haptics to web — these calls fail silently
 * and the UI relies on visual feedback instead.
 */

export function hapticLight(): void {
  if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
    try {
      navigator.vibrate(8);
    } catch {
      /* noop */
    }
  }
}

export function hapticMedium(): void {
  if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
    try {
      navigator.vibrate(15);
    } catch {
      /* noop */
    }
  }
}

export function hapticHeavy(): void {
  if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
    try {
      navigator.vibrate([30, 20, 30]);
    } catch {
      /* noop */
    }
  }
}
